<script setup>
import { computed, defineProps } from 'vue';
import { useStore } from 'vuex'

const props = defineProps({
   or_edit_logs: {
    type: [Object, null]
   }
});

const store = useStore();

const loading = computed(() => store.state.globals.loading);
</script>

<template>
<b-overlay :show="loading">
    <div class="p-3">
        <table class="table table-bordered table-sm table-light">
            <tbody v-if="props.or_edit_logs && props.or_edit_logs.length">
                <tr>
                    <th colspan="2" class="text-center">OR Edit Logs</th>
                </tr>
                <tr>
                    <th class="text-center">OR No.</th>
                    <th class="text-center">Amount</th>
                    <th class="text-center">User</th>
                    <th class="text-center">Note</th>
                    <th class="text-center">Date / Attachment</th>
                </tr>
                <tr v-for="(log, index) in props.or_edit_logs" :key="index">
                    <td class="text-center">{{ log.or_number ? log.or_number : 'n/a' }}</td>
                    <td class="text-center">{{ log.amount ? log.amount : 'n/a' }}</td>
                    <td class="text-center">{{ log.user ? log.user : 'n/a' }}</td>
                    <td class="text-center">{{ log.note ? log.note : 'n/a' }}</td>
                    <td class="text-center">{{ log.date ? log.date : 'n/a' }}</td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <th colspan="5" class="text-center">OR Edit Logs</th>
                </tr>
                <tr>
                    <th class="text-center">OR No.</th>
                    <th class="text-center">Amount</th>
                    <th class="text-center">User</th>
                    <th class="text-center">Note</th>
                    <th class="text-center">Date / Attachment</th>
                </tr>
                <tr>
                    <td class="text-center" colspan="5">No OR Edit Logs found!</td>
                </tr>
            </tbody>
        </table>
    </div>
</b-overlay>
</template>

<style scoped>
.no-wrap{
  min-width: fit-content;
  width: 100px;
  white-space: nowrap;
}
th, td {
    background-color: #fff;
}
td{
  padding: 5px;
  text-align: center;
}
</style>
